import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { ArrowLeft, Mail } from "lucide-react";
import { LogoMark } from "../components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
    } catch (err) {
      // still show the same message — never reveal whether the email exists
    } finally {
      setSent(true);
      setLoading(false);
    }
  };

  return (
    <main className="pt-[68px] min-h-[80vh] flex items-center justify-center px-4">
      <motion.div
        data-testid="forgot-password-card"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white border border-[#E5E7EB] rounded-[2rem] p-8 sm:p-10 shadow-xl"
      >
        <div className="flex items-center gap-3 mb-2">
          <LogoMark size={36} className="rounded-xl" />
          <h1 className="font-display font-semibold text-2xl">Reset password</h1>
        </div>
        {sent ? (
          <div data-testid="forgot-password-sent">
            <Mail size={40} className="text-[#2563EB] my-5" />
            <p className="text-[#52525B] leading-relaxed">
              If <span className="font-semibold text-[#111827]">{email}</span>{" "}
              is registered, a reset link is on its way. It expires in 1 hour.
            </p>
            <Link
              to="/admin/login"
              className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[#111827] underline underline-offset-4"
            >
              <ArrowLeft size={15} /> Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <p className="text-sm text-[#71717a] mb-7">
              Enter your admin email and we&rsquo;ll send you a reset link.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#FFFFFF] border border-[#E5E7EB] rounded-xl px-4 py-3 focus:outline-none focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/30"
                placeholder="you@example.com"
              />
              <button
                data-testid="forgot-submit-button"
                type="submit"
                disabled={loading}
                className="w-full bg-[#111827] text-[#FFFFFF] font-bold py-3.5 rounded-full hover:bg-[#1F2937] transition-colors disabled:opacity-60"
              >
                {loading ? "Sending..." : "Send reset link"}
              </button>
            </form>
            <Link
              to="/admin/login"
              className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#71717a] hover:text-[#111827]"
            >
              <ArrowLeft size={15} /> Back to sign in
            </Link>
          </>
        )}
      </motion.div>
    </main>
  );
}
